module.exports = __webpack_public_path__ + "img/k_mysql.059fe62a.png";